import API from 'services/api';

import { IRegisterRenter } from '../models';

type TResponse = {
  id: number;
};

type TRequest = {
  email: string;
  customerId: string;
  payload: IRegisterRenter;
};

export const registerAnonymousRenter = ({
  payload: values,
  customerId,
}: TRequest): Promise<TResponse> => {
  return API.post(`/api/users/anonymous-renter-register/${customerId}`, values).then(
    response => response?.data,
  );
};
